<div>
  <div class="title">Wystąpił błąd...</div>
  <p>Szukana strona nie istnieje.</p>
  <p>Jeśli potrzebujesz skontaktować się z administratorem<ng-template [ngIf]="adminEmail">, napisz na adres: <a href="mailTo:{{ adminEmail }}">{{ adminEmail }}</a></ng-template></p>
  <button kendoButton [primary]="true" routerLink="/">Idź do strony głównej</button>
</div>
